export enum AppStatusCanoticCrowd {
    labeling = "labeling",
    reviewRequired = "reviewRequired",
    jobSubmitRequired = "jobSubmitRequired",
    calculatingMetrics = "calculatingMetrics",
    labelingSuspended = "labelingSuspended",
    configureMetricsRequired = "configureMetricsRequired",
    paymentMethodMissing = "paymentMethodMissing",
    acceptCalibrationJobsRequired = "acceptCalibrationJobsRequired"
}
